export var PatientDocumentationItemType;
(function (PatientDocumentationItemType) {
    PatientDocumentationItemType["TXU"] = "TXU";
    /**
     * A saved KI-Entwurf (TM-9504, Spec § 3.1). Always carries `ai_draft_id`
     * and the edited `payload`: `type = AI_ASSISTED ⇔ ai_draft_id IS NOT NULL`
     * is the machine-readable AI marking (Art. 50 Abs. 2 KI-VO), the UI shows
     * the label „KI-Entwurf" on it.
     */
    PatientDocumentationItemType["AI_ASSISTED"] = "AI_ASSISTED";
})(PatientDocumentationItemType || (PatientDocumentationItemType = {}));
//# sourceMappingURL=patient-documentation-item-type.enum.js.map